"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipService = void 0;
const constants_1 = require("../../constants");
const crypto_1 = require("@akord/crypto");
const service_1 = require("./service");
const contract_1 = require("../../types/contract");
const incorrect_encryption_key_1 = require("../../errors/incorrect-encryption-key");
class MembershipService extends service_1.Service {
    constructor(wallet, api, service) {
        super(wallet, api, service);
        this.objectType = constants_1.objectType.MEMBERSHIP;
    }
    setVaultContextFromMembershipId(membershipId, vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            const membership = yield this.api.getMembership(membershipId, vaultId);
            const vault = yield this.api.getVault(membership.vaultId);
            this.setVault(vault);
            this.setVaultId(membership.vaultId);
            this.setIsPublic(membership.__public__);
            yield this.setMembershipKeys(membership);
            this.setObject(membership);
            this.setObjectId(membershipId);
            this.setObjectType(this.objectType);
        });
    }
    getTxTags() {
        const _super = Object.create(null, {
            getTxTags: { get: () => super.getTxTags }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const tags = yield _super.getTxTags.call(this);
            return tags.concat(new contract_1.Tag(constants_1.protocolTags.MEMBERSHIP_ID, this.objectId));
        });
    }
    prepareMemberKeys(publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isPublic) {
                const keysEncrypter = new crypto_1.Encrypter(this.wallet, this.dataEncrypter.keys, (0, crypto_1.base64ToArray)(publicKey));
                try {
                    const keys = yield keysEncrypter.encryptMemberKeys([]);
                    return keys.map((keyPair) => {
                        delete keyPair.publicKey;
                        return keyPair;
                    });
                }
                catch (error) {
                    throw new incorrect_encryption_key_1.IncorrectEncryptionKey(error);
                }
            }
            else {
                return null;
            }
        });
    }
    rotateMemberKeys(publicKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const memberKeys = new Map();
            // generate a new vault key pair
            const keyPair = yield (0, crypto_1.generateKeyPair)();
            for (let [memberId, publicKey] of publicKeys) {
                const memberKeysEncrypter = new crypto_1.Encrypter(this.wallet, this.dataEncrypter.keys, (0, crypto_1.base64ToArray)(publicKey));
                try {
                    memberKeys.set(memberId, [yield memberKeysEncrypter.encryptMemberKey(keyPair)]);
                }
                catch (error) {
                    throw new incorrect_encryption_key_1.IncorrectEncryptionKey(error);
                }
            }
            return { memberKeys, keyPair };
        });
    }
}
exports.MembershipService = MembershipService;
